export const getLatestTimestamp = (deviceMetaData: Record<string, any>): number => {
    if (!deviceMetaData || typeof deviceMetaData !== 'object') return 0

    let latest = 0

    for (const key of Object.keys(deviceMetaData)) {
        const entry = deviceMetaData[key]
        if (entry && typeof entry === 'object') {
            const ts = entry.timestamp
            if (typeof ts === 'number' && ts > latest) {
                latest = ts
            }
        }
    }

    return latest
}


export function formatTimestamp(timestamp: number): string {
    if (timestamp === 0) return ''
    const date = new Date(timestamp * 1000)

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
}